import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { Grid } from '@mui/material';

export const DpProductGridCard = ({ href, image }: { href?: string; image: string }) => (
	<Grid item xs={6} md={4} display="flex">
		<Linkable href={href}>
			<Img
				src={image}
				sx={{
					objectFit: 'cover',
					width: { xs: '100%', md: '350px' },
					height: '100%',
				}}
			/>
		</Linkable>
	</Grid>
);
